<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        :title="title"
        :items="items"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/Common/Example/SimpleChildDetail"
        :parent-component="$options.name"
    >
      <template v-slot:item.add="{item}">
        <v-btn x-small @click="$emit('addmembers',item)">+</v-btn>
      </template>
      <template v-slot:item.remove="{item}">
        <v-btn x-small @click="$emit('removemembers',item)">-</v-btn>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import SimpleChildDetail from "@/components/Common/Example/SimpleChildDetail";

export default {
  name: "SimpleChildTable",

  props: {
    height: {default: null},
    items: {default: null},
    title: {type: [String], default: 'SimpleChildTable'},
    storeName: {type: [String], default: 'SimpleChildTable'},
    dtoDetailQuery: {default: 'SimpleChildDetailQueryDTO'},
    detailStoreName: {default: 'SimpleChildDetail'},
    dtoListQuery: {type: [String], default: 'SimpleChildListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SimpleChildActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'SimpleChildSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    SimpleChildDetail,
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    if (!!this.items)
      this.storeTable.headers = [
        {text: '-', value: 'remove', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
        {text: 'name', value: 'name', sortable: true, filterable: true, divider: true},
        {text: 'version', value: 'version', sortable: true, filterable: true, divider: true, width: 100},
        {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ]
    else
      this.storeTable.headers = [
        {text: '+', value: 'add', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
        {text: 'name', value: 'name', sortable: true, filterable: true, divider: true},
        {text: 'version', value: 'version', sortable: true, filterable: true, divider: true, width: 100},
        {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.dtoSaveCommand = this.dtoSaveCommand
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>